import baseRoute from '../baseRoute';

export type * from './viewModel';

type RouteDefinition =
	`${typeof baseRoute}/${number | ':jobId'}/jobTracking/table/xlsx/${number | ':processId'}`;

export const ROUTE: RouteDefinition =
	`${baseRoute}/:jobId/jobTracking/table/xlsx/:processId`;

export const URL = (
	jobId: number,
	processId: number
): RouteDefinition => `${baseRoute}/${jobId}/jobTracking/table/xlsx/${processId}`;
